'use strict';

export default {
  TIER_PROGRESS: {
    DATA: 'tierProgress',
    INDEX: 1
  },
  NAME: {
    DATA: 'name',
    INDEX: 2
  },
  NEXT_TIER_AP: {
    DATA: 'nextTierAP',
    INDEX: 3
  },
  TOTAL_PROGRESS: {
    DATA: 'totalProgress',
    INDEX: 4
  },
  REMAINING_AP: {
    DATA: 'remainingAP',
    INDEX: 5
  },
  CATEGORY: {
    DATA: 'category',
    INDEX: 6
  },
  DESCRIPTION: {
    DATA: 'description',
    INDEX: 7
  },
  REQUIREMENT: {
    DATA: 'requirement',
    INDEX: 8
  },
  REWARDS: {
    DATA: 'rewards',
    INDEX: 9
  },
  GROUP: {
    DATA: 'group.id',
    INDEX: 10
  },
  FLAGS: {
    DATA: 'flags',
    INDEX: 11
  },
  TYPE: {
    DATA: 'type',
    INDEX: 12
  },
  COUNT: {
    DATA: 'count',
    INDEX: 13
  },
  ID: {
    DATA: 'id',
    INDEX: 14
  }
};